<ng-container *ngIf="linkedJobIds">
    <div class="job-linking-list" style="width: 100%">
        <ion-list class="bg-transparent">
            <ion-item *ngFor="let linkedJob of linkedJobInfos; let linkedJobIndex = index" lines="full" class="bg-transparent">
                <div class="job-row">
                    <ng-container *ngIf="linkedJob.job != null; else linkedJobError">
                        <ion-label class="job-name ion-text-nowrap"> {{ linkedJob.job.jobNumber }} - {{ linkedJob.job.name }} </ion-label>
                        <div class="job-meta">
                            <span class="job-code" *ngIf="linkedJob.job.code != null && linkedJob.job.code != ''">
                                <ion-chip color="primary" outline="true">
                                    <fa-icon [icon]="['fal', 'qrcode']"></fa-icon>
                                    <ion-label>{{ linkedJob.job.code }}</ion-label>
                                </ion-chip>
                            </span>
                            <ng-container *ngIf="linkedJob.job.jobStatus?.customIconFields?.length > 0">
                                <ion-chip class="job-custom-icon-list" color="dark" outline="true">
                                    <ng-container *ngFor="let customIconField of linkedJob.job.jobStatus.customIconFields">
                                        <app-field-icon-view
                                            *ngIf="customIconField.icon?.iconName; else customValueInsteadOfIcon"
                                            class="job-custom-icon"
                                            [icon]="customIconField.icon"
                                            [color]="customIconField.color"
                                            limitSize="24px"
                                            faIconSize="lg"
                                            dpTooltip
                                            [tooltipContent]="customIconField.value"
                                        ></app-field-icon-view>
                                        <ng-template #customValueInsteadOfIcon>
                                            <span class="custom-icon-as-text" [ngStyle]="{ color: customIconField.color }">{{
                                                customIconField.value
                                            }}</span>
                                        </ng-template>
                                        <span
                                            class="custom-icon-combined-count"
                                            *ngIf="customIconField.combinedCount != null && customIconField.combinedCount > 1"
                                            >x{{ customIconField.combinedCount }}</span
                                        >
                                    </ng-container>
                                </ion-chip>
                            </ng-container>
                        </div>
                    </ng-container>
                    <ng-template #linkedJobError>
                        <ion-label>{{ linkedJob.notice }}</ion-label>
                    </ng-template>
                </div>
                <ion-buttons slot="end">
                    <ion-button
                        slot="end"
                        color="primary"
                        (click)="onViewLinkedJob(linkedJob.job)"
                        *ngIf="linkedJob.job && showDisplayLinkedJobButton(linkedJob.job.serviceGroupId)"
                    >
                        <fa-icon icon="eye" slot="icon-only"></fa-icon>
                    </ion-button>
                    <ion-button
                        *ngIf="settingsSrv.currentUserRights.canManageProjects"
                        slot="end"
                        color="danger"
                        (click)="onRemoveJobLink(linkedJobIndex)"
                    >
                        <fa-icon icon="unlink" slot="icon-only"></fa-icon>
                    </ion-button>
                </ion-buttons>
            </ion-item>
        </ion-list>
    </div>

    <ion-modal
        class="linked-job-modal"
        backdropDismiss="false"
        [isOpen]="linkedJobModalVisible"
        (didDismiss)="linkedJobModalVisible = false"
    >
        <ng-template>
            <ion-content class="ion-no-padding">
                <ng-container *ngIf="linkedJobModalJobData != null">
                    <app-job-details
                        [job]="linkedJobModalJobData"
                        [project]="linkedJobModalProjectData"
                        [serviceGroup]="linkedJobModalServiceGroupData"
                        [asDialog]="true"
                        [subView]="true"
                        (jobWasSaved)="onLinkedJobWasSaved($event)"
                    ></app-job-details>
                </ng-container>
            </ion-content>
        </ng-template>
    </ion-modal>
</ng-container>
